import Api from './Api';

const endPoint = 'users';

const isAdminUser = () => Api.get(`${endPoint}/isloggedinuseradmin`);

export {
  isAdminUser,
};
